import { apiClientWithRefreshToken } from "@/api/apiClient";
import { Payslip } from "@/v2/types";

export default async function UpdatePayslip({
    id,
    data,
}: {
    id: string;
    data: any;
}): Promise<Payslip> {
    const res = await apiClientWithRefreshToken({
        url: `/payslips/${id}`,
        method: "PUT",
        data: data,
    });

    return res.data;
}
